var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "permissionAccessModal" } },
      [
        _c("div", { staticClass: "modal-dialog success-modal-wrapper" }, [
          _c("div", { staticClass: "modal-content expiry-modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "card text-center" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12 card-text" }, [
                    _c("p", { staticClass: "success-message" }, [
                      _vm._v("Permission Status"),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12 card-text" }, [
                    _c("h5", { staticClass: "success-message" }, [
                      _vm._v(
                        " You currently do not have permissions to access this section, please contact your Admin. "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 ok-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-blue-button",
                      attrs: { "data-dismiss": "modal" },
                    },
                    [_vm._v("OK")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }